import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import messages from './messages';
import { FlexSection } from '../UIKit';
import './car.scss';
import CarCreator from '../CarCreator';

class Car extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, selectedBrand, selectedModel, carName, car } = this.props;
    const isCustomCar = car && car.id && car.is_custom;
    let buttonText;

    if (car.id) {
      buttonText = isCustomCar ? messages.editCar.title : messages.showCar.title;
    } else {
      buttonText = carName && carName.length ? messages.showCar.title : messages.newCar.title;
    }

    return (
      <div id="CarSelectorCar">
        <FlexSection
          title={title}
          children={
            <div>
              <span className="selected-car">{carName}</span>
              <CarCreator
                brand={selectedBrand}
                modello={selectedModel}
                isCustomCar={isCustomCar === true}
                carId={car.id}
                button={buttonText}
              />
            </div>
          }
        />
      </div>
    );
  }
}

Car.defaultProps = {
  errors: {},
  carName: '-',
};
Car.propTypes = {
  title: PropTypes.string.isRequired,
  selectedBrand: PropTypes.string.isRequired,
  selectedModel: PropTypes.string,
  carName: PropTypes.string,
  car: PropTypes.object,
};

export function mapDispatchToProps(dispatch) {
  return {};
}
const mapStateToProps = createStructuredSelector({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Car);
